import { Field, Formik, ErrorMessage, Form } from "formik";
import React, { useState, useEffect } from "react";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import AsyncSelect from "react-select/async";
import { getSuperAdminAllRole } from "../../../_redux/master-data-user/masterDataUserCrud";
import {
  findOrganizationRegional,
  findAllOrgRegional
} from "../../../_redux/organization-regional/organizationRegionalCrud";
import { genOptionLoaderDebounced } from "../../../../../../_metronic/_helpers/fetchUtils";

export default function MasterDataUserDialogForm({
  onSubmit,
  defaultValues,
  onHide,
  user
}) {
  const [userActiveUntil, setUserActiveUntil] = useState(null);
  const [regionalList, setRegionalList] = useState([]);
  const [accessRole, setAccessRole] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  let validationSchema;

  if (defaultValues && defaultValues.uuid) {
    Yup.object({
      name: Yup.string()
        .min(3, "Minimal 3 karakter!")
        .max(50, "Maksimal 50 karakter!")
        .required("Nama tidak boleh kosong!"),
      email: Yup.string()
        .required("Email tidak boleh kosong!")
        .email("Email tidak valid!"),
      change_pass: Yup.bool(),
      password: Yup.string().when("change_pass", {
        is: true,
        then: Yup.string()
          .min(6, "Minimal 6 karakter!")
          .required("Password tidak boleh kosong!"),
        otherwise: Yup.string()
      }),
      is_active: Yup.bool().required("Status aktif wajib diisi!"),
      role: Yup.string().required("Role wajib diisi!")
    });
  } else {
    validationSchema = Yup.object({
      name: Yup.string()
        .min(3, "Minimal 3 karakter!")
        .max(50, "Maksimal 50 karakter!")
        .required("Nama tidak boleh kosong!"),
      email: Yup.string()

        .required("Email tidak boleh kosong!")
        .email("Email tidak valid!"),
      password: Yup.string()
        .min(6, "Minimal 6 karakter!")
        .required("Password tidak boleh kosong!"),
      is_active: Yup.bool().required("Status aktif wajib diisi!"),
      role: Yup.string().required("Role wajib diisi!")
    });
  }

  useEffect(() => {
    const fetchSuperAdminAccessRole = async () => {
      getSuperAdminAllRole()
        .then(({ data }) => {
          setAccessRole(data.data);
        })
        .catch(err => {
          setAccessRole([]);
        });
    };

    fetchSuperAdminAccessRole();
  }, []);

  useEffect(() => {
    const fetchOrgRegional = async () => {
      findAllOrgRegional()
        .then(({ data }) => {
          let dataOptions = data.data.map(item => {
            return {
              value: item.uuid,
              label: item.name
            };
          });
          setRegionalList(dataOptions);
        })
        .catch(err => {
          setRegionalList([]);
        });
    };

    fetchOrgRegional();
  }, []);

  useEffect(() => {
    if (defaultValues && defaultValues.uuid) {
      setUserActiveUntil(defaultValues.active_until);
    } else {
      setUserActiveUntil(null);
    }
  }, [defaultValues]);

  const changePasswordToggler = e => {
    setIsEdit(!isEdit);
  };

  return (
    <Formik
      initialValues={defaultValues}
      validationSchema={validationSchema}
      onSubmit={values => {
        onSubmit(values);
      }}
      enableReinitialize={true}
    >
      {({ setFieldValue, handleSubmit, values }) => {
        return (
          <>
            <div className="form-group row">
              <div className="col">
                <Field
                  name="name"
                  label="Nama"
                  component={Input}
                  value={values.name}
                  placeholder="Nama"
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                <Field
                  name="hp"
                  label="Nomor Handphone"
                  component={Input}
                  value={values.hp}
                  placeholder="085xx"
                  type="string"
                  onInput={e => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                <Field
                  name="email"
                  component={Input}
                  label="Email"
                  type="email"
                  value={values.email}
                  placeholder="Email"
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-lg-12">
                <label>
                  <strong>Status Aktif</strong>
                </label>
                <Select
                  name="is_active"
                  onChange={e => {
                    setFieldValue("is_active", e.target.value);
                  }}
                >
                  <option value={true}>Ya</option>
                  <option value={false}>Tidak</option>
                </Select>
                <ErrorMessage
                  name="is_active"
                  render={msg => <div style={{ color: "red" }}>{msg}</div>}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-lg-12">
                <label>
                  <strong>
                    Aktif Sampai Dengan (Kosongkan Jika Ingin Selamanya)
                  </strong>
                </label>
                {/* {userActiveUntil === null ? (
                  <Field
                    name="active_until"
                    component={TextField}
                    className="form-control"
                    onChange={e => {
                      setFieldValue("active_until", e.target.value);
                      setUserActiveUntil(e.target.value);
                    }}
                    type="date"
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                ) : ( */}
                <Field
                  name="active_until"
                  component={TextField}
                  value={userActiveUntil}
                  className="form-control"
                  onChange={e => {
                    setFieldValue("active_until", e.target.value);
                    setUserActiveUntil(e.target.value);
                  }}
                  type="date"
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                {/* )} */}
              </div>
            </div>
            <div className="form-group row">
              <div className="col-lg-12">
                <Select
                  name="role"
                  label="Role"
                  onChange={e => {
                    setFieldValue("role", e.target.value);
                    setFieldValue(
                      "superadmin_role_uuid",
                      accessRole.find(item => item.name === e.target.value).uuid
                    );
                  }}
                >
                  <option value="">-PILIH-</option>
                  {accessRole.map(row => (
                    <option key={row.uuid} value={row.name}>
                      {row.name}
                    </option>
                  ))}
                </Select>
                <ErrorMessage
                  name="role"
                  render={msg => <div style={{ color: "red" }}>{msg}</div>}
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col-lg-12">
                <label>
                  <strong>Region (Kosongkan untuk role pusat)</strong>
                </label>
                <AsyncSelect
                  defaultOptions={regionalList}
                  isDisabled={user.regional_uuid}
                  loadOptions={genOptionLoaderDebounced(
                    inputValue =>
                      findOrganizationRegional({
                        pageNumber: 1,
                        pageSize: 10,
                        filter: {
                          name: inputValue
                        }
                      }),
                    ({ uuid, name }) => ({ label: name, value: uuid })
                  )}
                  value={
                    values.regional_uuid
                      ? {
                          label: values.regional_name,
                          value: values.regional_uuid
                        }
                      : null
                  }
                  placeholder
                  onChange={e => {
                    const { value, label } = e ?? {};
                    setFieldValue("regional_uuid", value);
                    setFieldValue("regional_name", label);
                  }}
                  isClearable
                />
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                {defaultValues?.uuid && (
                  <label>
                    <Field
                      name="change_pass"
                      type="checkbox"
                      checked={isEdit}
                      onChange={e => {
                        changePasswordToggler(e);
                        setFieldValue("change_pass", e.target.checked);
                        setFieldValue("password", "");
                      }}
                    />{" "}
                    <strong>Change&nbsp;</strong>
                  </label>
                )}
                <Field
                  name="password"
                  component={Input}
                  type="password"
                  label="Password"
                  value={values.password}
                  placeholder="Password"
                  disabled={defaultValues?.uuid && !isEdit ? true : false}
                />
              </div>
            </div>
            <button
              className="btn btn-primary float-right mx-1"
              onClick={handleSubmit}
              type="submit"
            >
              Simpan
            </button>
            <button
              className="btn btn-secondary float-right mx-1"
              onClick={onHide}
              type="button"
            >
              Tutup
            </button>
          </>
        );
      }}
    </Formik>
  );
}
